// extracted by mini-css-extract-plugin
module.exports = {"rotate":"mobile-rotate-module--rotate--nTn7Z","phone":"mobile-rotate-module--phone--2I3Nk","animRotate":"mobile-rotate-module--anim-rotate--1V0yN"};